<!------------------------------

     Table Wrapper

------------------------------->

<sb-table-wrapper
  (optionsChange)="requestDebounced($event)"
  [itemsData]="devices" [loading]="loading"
  [options]="options" [isInIntegratedContext]="true"
  [showExactMatch]="true" headline="{{'lang.headlines.devices' | translate}}" [itemName]="'devices'">
  <!------------------------------

      Header More

------------------------------->
  <div header-more>
    <sb-button ngbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top" container="body"
               classes="btn-secondary actionButtonMinWidth" (click)="requestDebounced()" [disabled]="loading"
               [loading]="loading">
      <sb-icon icon="refresh"></sb-icon>
    </sb-button>
    <a [sbRouterLink]="util.RoutingID.devices" [queryParams]="{'channelIds': getChannelId()}">
      <button class="btn btn-primary">{{'lang.globals.showInList' | translate}}</button>
    </a>
  </div>

  <!------------------------------

     Table Header

------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        {{'lang.globals.status' | translate}}
      </th>
      <th>
        {{'lang.globals.connection' | translate}}
      </th>
      <th>
        {{'lang.globals.id' | translate}}
      </th>
      <th>
        {{'lang.globals.location' | translate}}
      </th>
      <th class="tr">
        {{'lang.globals.actions'| translate}}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

   Table Body

------------------------------->
  <ng-template #tbody let-device>
    <tr>
      <td sb-device-online-status-icon [device]="device" class="sw">
      </td>
      <td>
        <!-- id/status/... Column -->
        <p sb-device-online-status [device]="device" class="mb-1">
        </p>
        <!---->
      </td>
      <td>
        {{device?.id}}
      </td>
      <td>
        <sb-comp-link
          [title]="device?.location?.name"
          [permission]="permissionService.Permission.location_show"
          [link]="util.RoutingID.locationDetails"
          [pathParams]="[{id: 'locationID', value: device?.location?.id }]">
        </sb-comp-link>
      </td>
      <td class="tr">
        <a [sbRouterLink]="util.RoutingID.deviceDetails" [pathParams]="[{id: 'deviceID', value: device?.id }]"
           ngbTooltip="{{'lang.globals.openDetails' | translate}}" placement="left" container="body">
          <sb-button classes="btn-hover-primary">
            <sb-icon icon="details"></sb-icon>
          </sb-button>
        </a>
      </td>
    </tr>
  </ng-template>
</sb-table-wrapper>
